import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'claims-v2';
export const claimsV2ServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const ClaimsV2ServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: claimsV2ServiceEventType(),
}));
